import React, { useState } from 'react';
import { useQuotations } from '../hooks/useQuotations';
import QuotationList from '../components/quotations/QuotationList';
import QuotationForm from '../components/quotations/QuotationForm';
import { CreateQuotationData } from '../types/quotation';
import Modal from '../components/common/Modal';
import { PlusIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../contexts/LanguageContext';
import CommonPageHeader from '../components/common/CommonPageHeader';
import toast from 'react-hot-toast';

const Quotations: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { createQuotation } = useQuotations();
  const { t } = useLanguage();

  const handleCreateQuotation = async (data: CreateQuotationData) => {
    try {
      await createQuotation(data);
      setIsModalOpen(false);
      toast.success(t('common.messages.quotation.createSuccess'));
    } catch (error) {
      console.error('Error creating quotation:', error);
      toast.error(t('common.messages.quotation.createError'));
    }
  };

  return (
    <div className="space-y-4">
      <CommonPageHeader
        title={t('quotations.title')}
        subtitle="Árajánlatok kezelése és nyomon követése"
        icon={DocumentTextIcon}
        showLastUpdate={false}
      >
        <button
          onClick={() => setIsModalOpen(true)}
          className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-lg hover:bg-white/30 transition-colors"
        >
          <PlusIcon className="w-5 h-5 mr-2" />
          {t('quotations.new')}
        </button>
      </CommonPageHeader>
      
      <QuotationList onNewClick={() => setIsModalOpen(true)} hideHeader={true} />

      <QuotationForm
        isOpen={isModalOpen}
        onSubmit={handleCreateQuotation}
        onCancel={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default Quotations; 